module.exports = __webpack_public_path__ + "img/no_mail.1b17e180.svg";